import axios from 'axios';
import pathfinder from '@fiverr-private/pathfinder';
import { logAPIError } from '../../../utils/logger';
import { GET_INDUSTRIES_AUTOCOMPLETE_ERROR } from './constants';

/**
 * Fetch industries autocomplete
 * @param {String} term
 * @param {Boolean} visibleForSellers
 * @returns {[Promise<IndustriesAutoComplete>, CancelTokenSource]}
 */
const getIndustriesAutocomplete = (term, visibleForSellers) => {
    const requestUrl = pathfinder('logo_maker_buyer_ajax', { endpoint: 'getIndustriesAutocomplete' });

    const source = axios.CancelToken.source();
    const promise = axios.post(requestUrl, { term, visibleForSellers }, { cancelToken: source.token })
        .then(({ data }) => {
            if (data.error) {
                throw new Error(data.error);
            }

            return data;
        })
        .catch((error) => {
            if (axios.isCancel(error)) {
                return Promise.reject();
            }
            logAPIError(error, { error: GET_INDUSTRIES_AUTOCOMPLETE_ERROR });
        });

    return [promise, source];
};

export default getIndustriesAutocomplete;
